import * as angular from "angular";

/* @ngInject */
function latLngToAddress($q, analyticsService) {
  return function (lat, lng, getFullAddress) {
    const defer = $q.defer();

    const geocoder = new google.maps.Geocoder();
    const latlng = new google.maps.LatLng(lat, lng);

    geocoder.geocode({location: latlng}, (results, status) => {
      analyticsService.trackEvent('Geocode', 'latLngToAddress', status);
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        defer.resolve(getFullAddress ? results[0] : results[0].formatted_address);
      }
      defer.resolve(null);
    });

    return defer.promise;
  };
}

angular
  .module('bringoz.admin.commons')
  .service('latLngToAddress', latLngToAddress);
